module.exports = __webpack_public_path__ + "img/steam-download-logo.4db4f01a.png";